module.exports = __webpack_public_path__ + "img/logowhite.c66fd017.png";